import useFilters from "features/FilterDrawer/hooks/useFilters";
import { getQueryFromFilters } from "features/FilterDrawer/utils/queryParams/filterQueryParams";
import { SearchSettingsProperties } from "helpers/services/mixpanel/events";
import useProToggle from "hooks/useProToggle";
import useSearchMode from "hooks/useSearchMode";

/**
 * Custom hook for generating the search settings properties to be used in mixpanel events for tracking new search events.
 * The search settings properties with the query omitted is returned.
 */
export function useNewSearchSettingsProperties() {
  const { isProToggleOn } = useProToggle();
  const { currentSearchMode } = useSearchMode();
  const { appliedFilters, appliedFilterCount } = useFilters();

  const newSearchSettingsProperties: Omit<SearchSettingsProperties, "query"> = {
    filters: getQueryFromFilters(appliedFilters),
    filtersOn: appliedFilterCount > 0,
    proAnalysisOn: isProToggleOn,
    searchMode: currentSearchMode,
  };

  return {
    newSearchSettingsProperties,
  };
}
